import React, { useState, useEffect } from 'react'
import axios from 'axios'
import moment from 'moment'
import Title from '../Title/Title'

// Not sure if this is being used anymore...
// Ryan doubts is it being used since it is being sent with the CIA now...


import './ShadeWaiver.css'

const ShadeWaiver = (props) => {

  // console.log(props)

  const [proposal, setProposal] = useState('')
  const [customer, setCustomer] = useState('')

  const getProposal = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_proposal', prop_id: props.match.params.prop_id }).then((res) => {
      console.log(res.data.data)
      return [setProposal(res.data.data)]
    })
  }

  const getCustomer = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_info', project_id: proposal.projectId }).then((res) => {
      console.log(res.data)
      return [setCustomer(res.data.data)]
    })
  }

  useEffect(() => {
    getProposal()
  }, [])

  useEffect(() => {
    if (proposal?.projectId) {
      getCustomer()
    }
  }, [proposal])

  // console.log(customer.name)

  return (


    <div className='shadeWaiver'>
      <Title title={`Shade Waiver-${proposal.systemSize / 1000}-${customer.name}`} />
      <div className='shadeInfo'>
        <div >
          <span>{moment().format('MM/DD/YYYY')}</span>
        </div>
        <div className='shadeInfo2'>
          <div>
            <span>{customer.street} {customer.city}, {customer.state} {customer.zip}</span>
          </div>
          <div>
            <span>{customer.name}</span>
          </div>
        </div>
        <div className='shadeInfo3'>
          <span>{customer.name},</span>
        </div>
      </div>
      <div className='systemSize'>
        <span>{proposal.systemSize / 1000}</span>
      </div>
    </div>
  )
}
export default ShadeWaiver
